"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXTFIELD_COMPONENT_MAP = exports.DROPZONE_COMPONENT_MAP = exports.PROFILEAVATAR_COMPONENT_MAP = exports.AVATARGROUP_COMPONENT_MAP = exports.AVATAR_COMPONENT_MAP = exports.LOGO_COMPONENT_MAP = exports.LOGOANDNAME_COMPONENT_MAP = exports.TOOLTIP_COMPONENT_MAP = exports.CUSTOM_ICONBUTTON_COMPONENT_MAP = exports.ICONBUTTON_COMPONENT_MAP = exports.BUTTON_COMPONENT_MAP = exports.COMPONENT_MAP = void 0;
var Avatar_1 = __importDefault(require("atomicComponents/atoms/Avatar"));
var AvatarGroup_1 = __importDefault(require("atomicComponents/atoms/Avatar/AvatarGroup"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var TextField_1 = __importDefault(require("atomicComponents/atoms/Forms/TextField"));
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var CustomIconButtons_1 = require("atomicComponents/molecules/IconButtons/CustomIconButtons");
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var ProfileAvatar_1 = __importDefault(require("atomicComponents/molecules/Image/ProfileAvatar"));
var FieldDropzone_1 = __importDefault(require("components/Form/FieldDropzone"));
exports.COMPONENT_MAP = {
    Button: Button_1.default,
    LineButton: LineButton_1.default,
    TextButton: TextButton_1.default,
    BlendButton: BlendButton_1.default,
    DownloadInvoiceButton: IconButtons_1.DownloadInvoiceButton,
    ExpandMenuButton: IconButtons_1.ExpandMenuButton,
    RemoveButton: IconButtons_1.RemoveButton,
    UndoButton: IconButtons_1.UndoButton,
    CloseButton: IconButtons_1.CloseButton,
    AddButton: IconButtons_1.AddButton,
    DollarSignButton: IconButtons_1.DollarSignButton,
    CurrencyIconButton: CustomIconButtons_1.CurrencyIconButton,
    DecimalIconButton: CustomIconButtons_1.DecimalIconButton,
    InvalidSpendIconButton: CustomIconButtons_1.InvalidSpendIconButton,
    Tooltip: Tooltip_1.default,
    LogoAndName: LogoAndName_1.default,
    Logo: Logo_1.default,
    AvatarGroup: AvatarGroup_1.default,
    Avatar: Avatar_1.default,
    ProfileAvatar: ProfileAvatar_1.default,
    FieldDropzone: FieldDropzone_1.default,
    TextField: TextField_1.default,
};
exports.BUTTON_COMPONENT_MAP = {
    Button: Button_1.default,
    LineButton: LineButton_1.default,
    TextButton: TextButton_1.default,
    BlendButton: BlendButton_1.default,
};
exports.ICONBUTTON_COMPONENT_MAP = {
    DownloadInvoiceButton: IconButtons_1.DownloadInvoiceButton,
    ExpandMenuButton: IconButtons_1.ExpandMenuButton,
    RemoveButton: IconButtons_1.RemoveButton,
    UndoButton: IconButtons_1.UndoButton,
    CloseButton: IconButtons_1.CloseButton,
    AddButton: IconButtons_1.AddButton,
    DollarSignButton: IconButtons_1.DollarSignButton,
};
exports.CUSTOM_ICONBUTTON_COMPONENT_MAP = {
    CurrencyIconButton: CustomIconButtons_1.CurrencyIconButton,
    DecimalIconButton: CustomIconButtons_1.DecimalIconButton,
    InvalidSpendIconButton: CustomIconButtons_1.InvalidSpendIconButton,
};
exports.TOOLTIP_COMPONENT_MAP = {
    Tooltip: Tooltip_1.default,
};
exports.LOGOANDNAME_COMPONENT_MAP = {
    LogoAndName: LogoAndName_1.default,
};
exports.LOGO_COMPONENT_MAP = {
    Logo: Logo_1.default,
};
exports.AVATAR_COMPONENT_MAP = {
    Avatar: Avatar_1.default,
    ProfileAvatar: ProfileAvatar_1.default,
};
exports.AVATARGROUP_COMPONENT_MAP = {
    AvatarGroup: AvatarGroup_1.default,
};
exports.PROFILEAVATAR_COMPONENT_MAP = {
    ProfileAvatar: ProfileAvatar_1.default,
};
exports.DROPZONE_COMPONENT_MAP = {
    FieldDropzone: FieldDropzone_1.default,
};
exports.TEXTFIELD_COMPONENT_MAP = {
    TextField: TextField_1.default,
};
